
import { useState, useEffect } from 'react'
import { useHistory, useParams, Link } from 'react-router-dom'
import { FaArrowLeft, FaSave } from 'react-icons/fa'
import { TeacherGet, TeacherUpdate } from "services/teacherService"

import { useDispatch, useSelector } from 'react-redux'
import { AppDispatch, RootState } from 'store'
import { fetchLicenseClasses } from 'store/licenseSlice'
import {toast} from 'react-hot-toast'
import { FILTER_KEYWORDS } from 'constants/filterKeywords'
import {fetchPartners} from "store/partnerSlice";
import { ArrowLeft, Save } from 'lucide-react';

export default function EditTeacherPage() {
    const {id}: any = useParams()
    const router = useHistory()
    const dispatch = useDispatch<AppDispatch>()

    const licenseClasses = useSelector((state: RootState) => state.licenseClasses.items)
    const partners = useSelector((state: RootState) => state.partners.items)


    const filteredLicenseClasses = licenseClasses.filter(license => {
        return !FILTER_KEYWORDS.some(keyword =>
            license.name.toLowerCase().includes(keyword.toLowerCase())
        );
    });


    const [fullName, setFullName] = useState('')
    const [userName, setUserName] = useState('')
    const [mobile, setMobile] = useState('')
    const [licenseClassId, setLicenseClassId] = useState('')
    const [partnerId, setPartnerId] = useState('')
    const [error, setError] = useState('')
    const [isLoading, setIsLoading] = useState(false)

    useEffect(() => {
        const fetchTeacher = async () => {
            try {

                if (licenseClasses.length === 0) {
                    await dispatch(fetchLicenseClasses())
                }

                if (partners.length === 0) {
                    await dispatch(fetchPartners())
                }
                const response = await TeacherGet(id as string)
                if (!response.result) {
                    throw new Error('Failed to fetch teacher')
                }
                const data = response.result
                setUserName(data.userName)
                setFullName(data.fullName)
                setMobile(data.mobile || '')
                setLicenseClassId(data.licenseClassId)
                setPartnerId(data.partnerId || '')
            } catch (err) {
                setError('Không thể tải thông tin giáo viên')
            }
        }

        fetchTeacher()
    }, [id])

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault()

        if (!fullName || !licenseClassId) {
            setError('Vui lòng điền đầy đủ thông tin bắt buộc')
            return
        }

        setIsLoading(true)
        setError('')

        try {
            const response = await TeacherUpdate({
                id: id,
                userName,
                fullName,
                mobile,
                licenseClassId,
                partnerId: partnerId || null
            })

            if (!response.result) {
                throw new Error(response.message || 'Failed to update teacher')
            }
            router.push('/teachers')
            toast.success('Cập nhật giáo viên thành công')
        } catch (err: any) {
            setError(err.message || 'Đã xảy ra lỗi khi cập nhật giáo viên')
        } finally {
            setIsLoading(false)
        }
    }

    return (
        <div className="container mx-auto px-4 py-8">
            <div className="flex justify-between items-center mb-6">
                <Link
                    to="/teachers"
                    className="flex items-center text-blue-600 hover:text-blue-800"
                >
                    <ArrowLeft className="mr-2" />
                    Quay lại
                </Link>
                <h1 className="text-3xl font-bold text-gray-800">Chỉnh sửa thông tin giáo viên</h1>
                <div></div>
            </div>

            <div className="bg-white rounded-lg shadow-md p-6 max-w-2xl mx-auto">
                {error && (
                    <div className="mb-4 p-3 bg-red-50 text-red-700 rounded-md">
                        {error}
                    </div>
                )}

                <form onSubmit={handleSubmit}>
                    <div className="mb-4">
                        <label htmlFor="fullName" className="block text-sm font-medium text-gray-700 mb-1">
                            Họ và tên *
                        </label>
                        <input
                            type="text"
                            id="fullName"
                            value={fullName}
                            onChange={(e) => setFullName(e.target.value)}
                            className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                            required
                        />
                    </div>

                    <div className="mb-4">
                        <label htmlFor="mobile" className="block text-sm font-medium text-gray-700 mb-1">
                            Số điện thoại
                        </label>
                        <input
                            type="text"
                            id="mobile"
                            value={mobile}
                            onChange={(e) => setMobile(e.target.value)}
                            className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                        />
                    </div>

                    <div className="mb-6">
                        <label htmlFor="licenseClass" className="block text-sm font-medium text-gray-700 mb-1">
                            Hạng đào tạo *
                        </label>
                        <select
                            id="licenseClass"
                            value={licenseClassId}
                            onChange={(e) => setLicenseClassId(e.target.value)}
                            className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                            required
                        >
                            <option value="">Chọn hạng đào tạo</option>
                            {filteredLicenseClasses.map((lc) => (
                                <option key={lc.id} value={lc.id}>
                                    {lc.name}
                                </option>
                            ))}
                        </select>
                    </div>

                    <div className="mb-6">
                        <label htmlFor="partner" className="block text-sm font-medium text-gray-700 mb-1">
                            Đơn vị liên kết
                        </label>
                        <select
                            id="partner"
                            value={partnerId}
                            onChange={(e) => setPartnerId(e.target.value)}
                            className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                        >
                            <option value="">Không</option>
                            {partners.map((partner) => (
                                <option key={partner.id} value={partner.id}>
                                    {partner.name}
                                </option>
                            ))}
                        </select>
                    </div>

                    <div className="flex justify-end">
                        <button
                            type="submit"
                            disabled={isLoading}
                            className="flex items-center px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 disabled:opacity-50"
                        >
                            {isLoading ? (
                                <>
                                    <svg className="animate-spin -ml-1 mr-2 h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                        <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                    </svg>
                                    Đang lưu...
                                </>
                            ) : (
                                <>
                                    <Save className="mr-2" />
                                    Lưu thông tin
                                </>
                            )}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    )
}